import React, { useEffect, useRef, useState } from 'react'
import DataTable from '../../components/datatable'
import { useHistory } from 'react-router-dom'
import { PAGINATION_DEFAULT, employeeStatusConfig } from '../../utils/constants'
import Button from '../../components/button'
import { useSelector } from 'react-redux'
import { useDeleteSalary, useGetEmployeeSalaries } from '../../redux/admin/hook'
import UnauthorizedPage from '../errors/unauthorized'

const SalaryManagement = () => {
  useEffect(() => {}, [])
  const { section } = useSelector((state) => state.sectionSlice)
  const { mutateAsync: deleteCompensation } = useDeleteSalary()
  const { user } = useSelector((state) => state.userSlice)

  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    statusFilter: PAGINATION_DEFAULT.statusFilter,
    search: '',
  })

  const [tableType, setTableType] = useState('table')

  const switchFunction = () => {
    if (tableType === 'salary') {
      setTableType('table')
    } else {
      setTableType('salary')
    }
  }

  const { refetch, data: employeeSalaries } = useGetEmployeeSalaries(
    pagination?.limit,
    pagination?.page,
    pagination?.statusFilter,
    pagination?.search
  )

  const history = useHistory()

  const tableConfig = {
    // title: 'Salary Management',
    headers: [
      'Employee Name',
      'Mobile',
      'Basic',
      'Transportation',
      'Housing',
      'Others',
      'Gross pay',
      'Status',
    ],
    keys: [
      'employeeName',
      'phone',
      'formatted_basic_salary',
      'formatted_transportation_allowance',
      'formatted_housing_allowance',
      'formatted_other_accum_allowance',
      'formatted_gross_pay',
      'status',
    ],
    mobileHeader: {
      left: {
        title: 'Employee Name',
        key: 'employeeName',
      },
      right: {
        title: 'Mobile',
        key: 'phone',
      },
    },
  }

  const actionConfig = [
    {
      name: 'View',
      color: 'green',
      action: (id) => {
        let index = employeeSalaries.data.findIndex((item) => item.id === id)

        if (index != -1) {
          history.push(
            `/employees/view/${employeeSalaries.data[index].employee}`
          )
        }
      },
    },
    {
      name: 'Update',
      color: 'orange',
      action: (id) => {
        let index = employeeSalaries.data.findIndex((item) => item.id === id)
        if (index != -1) {
          history.push(
            `/employees/onboarding/add-salary-information?type=single&salary=true&update=true`
          )
        }
      },
    },
    // {
    //   name: 'Delete Salary',
    //   color: 'red',
    //   action: (id) => {
    //     let index = employeeSalaries.data.findIndex((item) => item.id === id)
    //     if (index != -1) {
    //       deleteCompensation(employeeSalaries.data[index].id)
    //     }
    //   },
    // },
  ]

  return (
    <div className='flex flex-col mt-4'>
      <div className='flex flex-col bg-white rounded border'>
        <div className='flex flex-col md:flex-row justify-between items-center px-4 gap-[10px] my-2 mt-3border'>
          <div className='md:flex hidden md:justify-start justify-center p3-bold header-4 md:w-[25%] w-full'>
            Salaries
          </div>
          <div className='flex flex-col md:flex-row items-start gap-[10px] md:justify-end md:w-[75%] w-full'>
            {user?.company?.employee?.permission_salary_write === 1 && (
              <div className='md:w-fit w-[100%]'>
                <Button
                  text='New Salary'
                  type='button'
                  theme='primary'
                  className='flex gap-2 !h-[35px] md:w-fit w-full px-2 items-center'
                  textClass={'!text-[11px]'}
                  leftIcon={'add'}
                  onClick={() => {
                    history.push(
                      '/employees/onboarding/select-option?salary=true'
                    )
                  }}
                />
              </div>
            )}

            {user?.company?.employee?.permission_salary_read === 1 && (
              <div className='md:w-fit w-[100%]'>
                <Button
                  text='Refresh'
                  type='button'
                  theme='primary'
                  className='flex gap-2 !h-[35px] md:w-fit w-full px-2 items-center'
                  textClass={'!text-[11px]'}
                  onClick={() => {
                    refetch()
                  }}
                />
              </div>
            )}
          </div>
        </div>
        <hr className='divider mt-2 mb-1' />
        {user?.company?.employee?.permission_salary_read === 1 ? (
          <DataTable
            data={employeeSalaries}
            tableConfig={tableConfig}
            statusConfig={employeeStatusConfig}
            actionConfig={actionConfig}
            updatePagination={(data) => setPagination(data)}
            filterByStatus={true}
            searchData={true}
            computedActions={true}
          />
        ) : (
          <UnauthorizedPage />
        )}
      </div>
    </div>
  )
}

export default SalaryManagement
